import { CANCELLED_WITH_VENDOR, CANCELLED_WITH_VENDOR_SUCCESS, CANCELLED_WITH_VENDOR_ERROR, CANCELLED_WITH_VENDOR_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CancelledWithVendor = (state = initialState, action) => {
  switch (action.type) {
    case CANCELLED_WITH_VENDOR:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CANCELLED_WITH_VENDOR_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CANCELLED_WITH_VENDOR_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CANCELLED_WITH_VENDOR_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CancelledWithVendor;
